// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_pu-0";